import DefaultCRUD from '../utils'

const resource = `/measurement/measurement-types`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
